export default {
      id: "ic_pin-usage",
      viewBox: "0 0 13 19",
      url: "/" + "images/icons.3.109.2.svg#ic_pin-usage",
      toString: function () {
        return this.url;
      }
    }